import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { CLICKABLE_COLOR, DARK_GREY_BG_COLOR } from '@CSSVars/colors'

export const _OverflowBox = styled.div`
  overflow-x: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar:vertical {
     display: none;
   }

  &::-webkit-scrollbar-track {
     background-color: rgba(0,0,0,.1);
     -webkit-border-radius: 0;
     border-radius: 0;
     border: 3px solid transparent;
     background-clip: content-box;
   }

  &::-webkit-scrollbar-thumb {
     border-radius: 0;
     border: 3px solid transparent;
     background: ${CLICKABLE_COLOR};
     background-clip: content-box;
   }

  &::-webkit-scrollbar-button:horizontal:end:increment {
     background-image: url(/static/svg/next.svg);
   }
  &::-webkit-scrollbar-button:horizontal:start:decrement {
     background-image: url(/static/svg/prev.svg);
   }
  &::-webkit-scrollbar-button:horizontal:end:increment,
  &::-webkit-scrollbar-button:horizontal:start:decrement {
     display: block;
     width: 25px;
     background-position: center;
     background-repeat: no-repeat;
   }
  &::-webkit-scrollbar {
    display: block;
    height: 11px;
    padding-top: 10px;
    -webkit-border-radius: 0;
    border-radius:0;
  }

  &::-webkit-scrollbar-corner { display: none; height: 0; width: 0; }
`

export const _MobileArrow = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: rotate(270deg) translateY(-50%);

  svg {
    fill: ${DARK_GREY_BG_COLOR};
    opacity: 0.4;
  }

`
